/* ARCK bulky-item surcharge NOTICE for MAIN template
 *
 * Behavior (mirrors arck-product.js for the ARCK section):
 *   1. On any /products/* page, fetch /products/{handle}.js to read tags
 *   2. If product is tagged "bulky", inject a notice box after the Add to Cart button
 *   3. Watch the quantity input; estimated surcharge = qty × $20 (live updates)
 *   4. Hide the dynamic checkout buttons so the customer goes via the cart page
 *
 * The surcharge LINE ITEM is no longer added here. This script used to hook the
 * add-to-cart form and do a dual add, which (a) only worked on the product page
 * — collection, search and quick-view adds silently escaped the surcharge — and
 * (b) hooked every add-to-cart form on the page, so adding a related product
 * from a bulky PDP charged $20 for a non-bulky item. The surcharge line is now
 * reconciled against the whole cart by assets/arck-bulky-surcharge.js, which
 * runs on every page and again immediately before checkout.
 *
 * SAFETY:
 *   - Skips if .arck-bulky-notice already exists (i.e. the ARCK section template
 *     already rendered one server-side — don't duplicate).
 *
 * Config (mirrors product.arck.json section settings):
 */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  var SURCHARGE_AMOUNT = 20.00;   // $ per item
  var BULKY_TAG = 'bulky';

  function getHandle() {
    var m = location.pathname.match(/\/products\/([^\/\?#]+)/);
    return m ? m[1] : null;
  }

  function formatMoney(n) {
    return '$' + n.toFixed(2);
  }

  function buildNoticeHtml() {
    return [
      '<div class="arck-bulky-notice" data-arck-bulky-injected="1" style="background:#FFF8EC;border:1.5px solid #F5A623;border-radius:8px;padding:14px 16px;display:flex;flex-direction:column;gap:8px;margin:12px 0;">',
      '  <div style="display:flex;align-items:center;gap:8px;">',
      '    <span style="color:#F5A623;flex-shrink:0;display:flex;" aria-hidden="true">',
      '      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">',
      '        <rect x="1" y="7" width="13" height="10" rx="1.5" stroke="currentColor" stroke-width="1.5"/>',
      '        <path d="M14 10H17L19 13V17H14V10Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>',
      '        <circle cx="5" cy="17" r="1.5" stroke="currentColor" stroke-width="1.5"/>',
      '        <circle cx="16" cy="17" r="1.5" stroke="currentColor" stroke-width="1.5"/>',
      '      </svg>',
      '    </span>',
      '    <strong style="font-size:14px;font-weight:700;color:#1a1a1a;">Bulky Item &mdash; Special Freight Required</strong>',
      '  </div>',
      '  <p style="margin:0;font-size:13px;color:#666;line-height:1.5;">',
      '    This item is oversized or heavy. For <strong style="color:#1a1a1a;">delivery</strong>, ',
      '    a flat surcharge of <strong style="color:#1a1a1a;">$' + SURCHARGE_AMOUNT.toFixed(2) + ' per item</strong> applies on top of standard shipping.',
      '  </p>',
      '  <div style="display:flex;align-items:center;justify-content:space-between;gap:12px;background:rgba(245,166,35,0.12);border-radius:6px;padding:10px 12px;">',
      '    <span style="font-size:13px;color:#1a1a1a;">',
      '      Estimated delivery surcharge for <span class="arck-bulky-notice__qty">1</span> item(s):',
      '    </span>',
      '    <strong class="arck-bulky-notice__total" style="font-size:15px;color:#1a1a1a;">' + formatMoney(SURCHARGE_AMOUNT) + '</strong>',
      '  </div>',
      '  <div style="display:flex;align-items:center;gap:8px;background:#e6f7ee;border:1px solid #b8e2c8;border-radius:6px;padding:10px 12px;">',
      '    <span style="color:#1a7a45;flex-shrink:0;display:flex;" aria-hidden="true">',
      '      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">',
      '        <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>',
      '      </svg>',
      '    </span>',
      '    <span style="font-size:13px;color:#1a1a1a;line-height:1.4;">',
      '      <strong style="color:#1a7a45;">Pickup is FREE</strong> &mdash; switch to <strong>Free Pickup</strong> on the cart page to remove this surcharge and collect from our North Parramatta branch.',
      '    </span>',
      '  </div>',
      '  <p style="margin:0;font-size:11px;color:#888;font-style:italic;">',
      '    Estimates only. Final freight is confirmed when your order is processed.',
      '  </p>',
      '</div>'
    ].join('\n');
  }

  function findInsertionPoint() {
    // Halo theme buy button container
    var candidates = [
      '.productView-buttons',
      '.product-form__buttons',
      '.product-form',
      'form[action="/cart/add"]',
      'form[id^="product-form-"]'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el) return el;
    }
    return null;
  }

  function hideDynamicCheckoutButtons() {
    // Inject a scoped <style> so any current/future dynamic-checkout containers
    // stay hidden even if the theme renders them after our JS runs.
    if (document.getElementById('arck-bulky-hide-dcb')) return;
    var s = document.createElement('style');
    s.id = 'arck-bulky-hide-dcb';
    s.textContent = [
      '.shopify-payment-button,',
      '.shopify-payment-button__button,',
      '[data-shopify-payment-button],',
      '[data-shopify-payments-button],',
      '.dynamic-checkout__content,',
      '.dynamic-checkout-buttons,',
      '.product-form__quantity + .shopify-payment-button,',
      '.additional-checkout-buttons,',
      '.shopify-cleanslate {',
      '  display: none !important;',
      '}'
    ].join('\n');
    (document.head || document.documentElement).appendChild(s);

    // Also remove any already-rendered instances (belt + braces in case the
    // CSS doesn't catch a custom theme variant).
    document.querySelectorAll(
      '.shopify-payment-button, .dynamic-checkout-buttons, [data-shopify-payment-button]'
    ).forEach(function (el) { el.style.display = 'none'; });
  }

  function findAllQuantityInputs() {
    // Halo theme renders multiple .quantity__input (main, sticky mobile, etc.)
    // Skip hidden inputs that are just form scaffolding.
    return Array.prototype.filter.call(
      document.querySelectorAll('.quantity__input, input[name="quantity"]'),
      function (el) { return el.type !== 'hidden'; }
    );
  }

  function findAllQuantityButtons() {
    // Halo theme +/- buttons: <button name="minus" class="minus btn-quantity">
    return document.querySelectorAll(
      '.btn-quantity, button[name="minus"], button[name="plus"], .quantity__button'
    );
  }

  function updateNotice(notice, qty) {
    var qtyEl = notice.querySelector('.arck-bulky-notice__qty');
    var totalEl = notice.querySelector('.arck-bulky-notice__total');
    if (qtyEl) qtyEl.textContent = qty;
    if (totalEl) totalEl.textContent = formatMoney(qty * SURCHARGE_AMOUNT);
  }

  function init(productJson) {
    if (!productJson || !Array.isArray(productJson.tags)) return;
    if (productJson.tags.indexOf(BULKY_TAG) === -1) return;

    // Bulky products: hide dynamic checkout buttons (Buy Now, Apple Pay, etc.)
    // so customers must use Add to Cart → go through the cart page (where the
    // Pickup vs Delivery toggle lives) instead of jumping past it.
    hideDynamicCheckoutButtons();

    // Don't duplicate if the ARCK section already rendered a notice
    if (document.querySelector('.arck-bulky-notice')) return;

    var anchor = findInsertionPoint();
    if (!anchor) return;

    // Inject after the buy buttons
    var wrapper = document.createElement('div');
    wrapper.innerHTML = buildNoticeHtml();
    var notice = wrapper.firstElementChild;
    anchor.parentNode.insertBefore(notice, anchor.nextSibling);

    // Wire qty inputs (there can be multiple: main, sticky, mobile) → live update
    var qtyInputs = findAllQuantityInputs();

    var getQty = function () {
      for (var i = 0; i < qtyInputs.length; i++) {
        var v = parseInt(qtyInputs[i].value, 10);
        if (!isNaN(v) && v > 0) return v;
      }
      return 1;
    };
    var doUpdate = function () { updateNotice(notice, getQty()); };
    doUpdate();

    // Native input/change events on every qty input
    qtyInputs.forEach(function (inp) {
      inp.addEventListener('input',  doUpdate);
      inp.addEventListener('change', doUpdate);
    });

    // Halo's +/- buttons update the input via JS without firing native events.
    // Click handler with setTimeout reads the new value after the theme updates it.
    findAllQuantityButtons().forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(doUpdate, 50);
        setTimeout(doUpdate, 200);  // belt and braces for slow updates
      });
    });

    // Fallback: poll every 500ms (cheap, fires updates if anything else changes qty)
    setInterval(doUpdate, 500);

    // The surcharge line item itself is added by assets/arck-bulky-surcharge.js,
    // which reconciles it against the whole cart no matter where the item was
    // added from. Nothing to hook here.
  }

  function bootstrap() {
    var handle = getHandle();
    if (!handle) return;
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) { if (json) init(json); })
      .catch(function () { /* fail silent */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
